export default __webpack_public_path__ + "static/media/visa.7b6f0f86.png";